import React, { Component } from 'react'
import { PAYMENTS_QUERY } from "../../queries/Queries"
import { useQuery } from '@apollo/react-hooks';
import CircularProgressIndicator from '../elements/CircularProgressIndicator';
import { AUTH_TOKEN } from '../../constants';
import Payment from './Payment';
import { FaSortDown, FaSortUp } from 'react-icons/fa';
import { flattenStrapiData } from '../../utils/utilities';

class PaymentList extends Component {

  state = {
    columns: [
      {column: "id", direction: "asc"},
      {column: "username", direction: "asc"},
      {column: "whents", direction: "asc"},
      {column: "state", direction: "asc"}
    ],
    sortBy: "id:desc"
  }

  updateColumn(at) {
    let column = this.state.columns[at]

    column.direction = column.direction === 'asc' ? 'desc' : 'asc'
    let columns = this.state.columns
    columns[at] = column
    let sortBy =  column.column + ":" + column.direction
    this.setState({columns: columns,
      sortBy: sortBy})
  }

  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    
    if(!token) {
      return(
        <div>
          <span className="Error">You must be loged in first</span>
        </div>
      )
    }

    return (
      <div>
          <GetList 
            updateColumn={this.updateColumn.bind(this)}
            columns={this.state.columns}
            sortBy={this.state.sortBy}/>
      </div>
    )
  }
}

function GetList({updateColumn, columns, sortBy}) {
  let limit = 50
  const {data, loading, error, refetch} = useQuery(PAYMENTS_QUERY, {variables: {sortBy: sortBy, limit: limit}})
  
  let payments = data?.payments?.data

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) return(<span className="error">{error.message}</span>)
      
  function sort(columnNumber) {
    updateColumn(columnNumber)
    refetch({variables: {sortBy: sortBy}})
  }

  function getArrow(direction) {
    return direction === "asc" ? <FaSortUp/> : <FaSortDown/>
  }
  
  return (
    <table className="table table-bordered">
      <tbody>
        <tr>
          <td onClick={() => sort(0)}><div><h4>Id</h4>{getArrow(columns[0].direction)}</div></td>
          <td ><div><h4>Username</h4></div></td>
          <td onClick={() => sort(2)}><div><h4>Date</h4>{getArrow(columns[2].direction)}</div></td>
          <td><h4>PointsAmount</h4></td>
          <td><h4>PricePayed</h4></td>
          <td><h4>Currency</h4></td>
          <td onClick={() => sort(3)}><div><h4>Payment State</h4>{getArrow(columns[3].direction)}</div></td>
          <td><h4>Description</h4></td>
          <td><h4>Source_token</h4></td>
        </tr>
        {payments && payments.map(payment => {
          payment = flattenStrapiData(payment)
          return <Payment key={payment.id} payment={payment}/>
        })}
      </tbody>
    </table>
  )
}

export default PaymentList